'use client';

import { c as _c } from "react/compiler-runtime";
import { pushResultAccordionEvent } from '@/globals/analytics/events/pushDecisionToolEvent';
import { AccordionItem, AccordionItemProps } from '@/uiComposites/interactive/accordion/AccordionItem.client';
export const ResultAccordionItem = t0 => {
  const $ = _c(8);
  let props;
  let titleText;
  if ($[0] !== t0) {
    ({
      titleText,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = titleText;
  } else {
    props = $[1];
    titleText = $[2];
  }
  let t1;
  if ($[3] !== titleText) {
    t1 = t2 => {
      const {
        opening
      } = t2;
      pushResultAccordionEvent({
        resultTitle: titleText,
        opening
      });
    };
    $[3] = titleText;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <AccordionItem {...props} onToggle={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};